import Box from '@mui/material/Box';

interface IPrimaryValueProps {
  value: string;
}

export function PrimaryValue ({ value }: IPrimaryValueProps) {
  return (
    <Box color="primary.main" component="span" fontSize="h5.fontSize">
      {value}
    </Box>
  )
}
